module.exports = window.fetch || (window.fetch = require('unfetch').default || require('unfetch'));



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-unfetch/browser.js
// module id = 295
// module chunks = 168707334958949